import type { NavigationItemType } from '@oppy/omniv2-core';
import { useMatches } from 'react-router-dom';

import { default as NavigationItem } from '../navigation-item';

type Props = {
  isSubMenu?: boolean;
  navigationItems: NavigationItemType[];
};

export default function NavigationItems({ isSubMenu, navigationItems }: Props) {
  const matches = useMatches();
  return (
    <ul data-testid="nav-items" className="flex flex-col gap-2">
      {navigationItems.map(item => (
        <li key={item.href}>
          <NavigationItem
            {...item}
            isSubItem={isSubMenu}
            isActive={matches.some(match => match.id === item.id)}
          />
        </li>
      ))}
    </ul>
  );
}
